import moment from "moment";

import { parseStoredPeriodDate } from "components/_refactor/fields/period-field";

const DATE_FORMATS = [
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  "MM-DD-YYYY",
  "YYYY-MM-DD",
];

function formatDateForApi(value) {
  if (value == null || value === "") return null;
  const m = parseStoredPeriodDate(value);
  if (m?.isValid()) return m.format("YYYY-MM-DD");
  const fallback = moment(String(value).trim(), DATE_FORMATS, true);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD") : null;
}

export function buildColetasApiFilters(filterState) {
  const filters = {};

  const dataInicio = formatDateForApi(filterState?.dataInicial);
  const dataFim = formatDateForApi(filterState?.dataFinal);
  if (dataInicio) filters.dataInicio = dataInicio;
  if (dataFim) filters.dataFim = dataFim;

  const tipo = filterState?.tipo?.value ?? filterState?.tipo;
  if (tipo) filters.tipoColeta = tipo;

  const sku = String(filterState?.sku ?? "").trim();
  if (sku) filters.sku = sku;

  const loja = filterState?.loja;
  if (loja?.idPessoaLoja != null) {
    filters.idPessoaLoja = loja.idPessoaLoja;
    if (loja.idGrupoEconomico != null) {
      filters.idGrupoEconomico = loja.idGrupoEconomico;
    }
  }

  const produto = filterState?.produto;
  if (produto?.id != null) {
    filters.idProdutoReferencia = produto.id;
  }

  return filters;
}

export default function buildColetasQueryParams(filterState, { page, pageSize } = {}) {
  const params = new URLSearchParams();

  if (page != null) params.set("page", String(page));
  if (pageSize != null) params.set("pageSize", String(pageSize));

  const apiFilters = buildColetasApiFilters(filterState);
  Object.entries(apiFilters).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  });

  const query = params.toString();
  return query ? `?${query}` : "";
}
